import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/deliveryletter/detail",
  },
  {
    path: "/deliveryletter",
    component: () => import("@/components/BasicLayout.vue"),
    children: [
      {
        path: "detail",
        name: "交付确认函外部确认详情",
        component: () => import("@/views/DeliveryLetter/LetterDetail"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
